import Head from 'next/head'
import { forwardRef, ReactNode } from 'react'
import { Box, BoxProps } from '@mui/material'

interface PageProps extends BoxProps {
  children: ReactNode
  title: string
  description?: string
  image?: string
  pageName?: string
  favicon?: string
}

const Page = forwardRef<HTMLDivElement, PageProps>(
  (
    { children, title = '', description = '', pageName = '', image = '', favicon = '', ...other },
    ref,
  ) => {
    return (
      <Box ref={ref} {...other}>
        <Head key={pageName}>
          <title>{title}</title>
          <meta name="twitter:image" content={image} />
          <meta property="og:title" content={description} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={description} />
          {image && <meta property="og:image" content={image} />}
          <meta property="og:type" content="article" />
          <meta property="og:locale" content="en_GB" />
          <meta property="og:type" content="website" />
          <meta property="og:image:type" content="image/jpg" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={favicon} type="image/png" />
          <link rel="shortcut icon" href={favicon} type="image/png" />
        </Head>
        {children}
      </Box>
    )
  },
)

export default Page
